import { Suspense } from 'react'

import { Outlet } from 'react-router-dom'

import AnalyticsNavigation from 'modules/Analytics/components/AnalyticsNavigation'

import { ContentLoader } from 'shared/ui/ContentLoader'
import Title from 'shared/ui/Title'

const AnalyticsWrapper = () => {
  return (
    <div>
      <div>
        <Title
          className="!mb-0 !px-[24px] !py-[12px] !font-bold !leading-[32px] !text-dark_2"
          level={3}
        >
          Аналитика
        </Title>
        <AnalyticsNavigation />
      </div>
      <div className="p-[20px] pt-0">
        <Suspense fallback={<ContentLoader />}>
          <Outlet />
        </Suspense>
      </div>
    </div>
  )
}

export default AnalyticsWrapper
